<template>
  <div>
    <div v-if="error != null">
      <div class="row">
        <div class="col">
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col">
          <p>Sobald ein Autor gespeichert ist, können Sie weitere Institute hinzufügen.</p>
        </div>
      </div>
    </div>
    <div v-if="importMode === null">
      <div class="row" v-if="importMode === null">
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              Manuell
            </div>
            <div class="card-body">
              <p class="card-text">Ich möchte den Autoren manuell eintragen.</p>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="manually()">Weiter</button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              Suche
            </div>
            <div class="card-body">
              <p class="card-text">Ich möchte einen Autoren aus der DGU Mitgliedsdatenbank importieren.</p>
              <div class="form-group">
                <label for="membernumber">Ihre Mitgliedsnummer:</label>
                <input type="text" class="form-control" aria-describedby="dguHelp" id="membernumber"
                       v-model="localmember">
                <small id="dguHelp" class="form-text text-muted">Der Import steht nur DGU Mitgliedern zur
                  Verfügung.</small>
              </div>
              <div class="row" v-if="validmember != null && !validmember">
                <div class="col">
                  <div class="alert alert-danger">Kein Import möglich!<br>Bitte geben Sie ihre gültige Mitgliedsnummer
                    an.
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="checkMember()">Weiter</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Abbruch</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'search' && selected === null">
      <div class="row">
        <div class="col">
          <div class="row form-group">
            <div class="col">
              <label class="col-form-label font-weight-bold p-0">
                <span>Vorname</span>
              </label>
              <input type="text" name="firstname" required="required" autocomplete="on" class="form-control"
                     v-model="searchfields.firstname" v-on:keydown.enter="search()">
            </div>
            <div class="col">
              <label class="col-form-label font-weight-bold p-0">
                <span>Nachname</span>
              </label>
              <input type="text" name="lastname" required="required" autocomplete="on" class="form-control"
                     v-model="searchfields.lastname" v-on:keydown.enter="search()">
            </div>
          </div>
          <div class="row form-group mt-3 mb-3">
            <div class="col">
              <div class="">
                <label class="col-form-label font-weight-bold p-0">
                  <span>Ort</span>
                </label>
                <input type="text" name="city" autocomplete="on" class="form-control" v-model="searchfields.city"
                       v-on:keydown.enter="search()">
              </div>
            </div>
          </div>
          <!--          <div class="row form-group mt-3 mb-3">-->
          <!--            <div class="col">-->
          <!--              <div class="">-->
          <!--                <label class="col-form-label font-weight-bold p-0">-->
          <!--                  <span>Land</span>-->
          <!--                </label>-->
          <!--                <treeselect-->
          <!--                    class="w-auto"-->
          <!--                    value-consists-of="BRANCH_PRIORITY"-->
          <!--                    v-model="searchfields.country" :options="this.countryData()"></treeselect>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="row">
            <div class="col d-flex">
              <Button class="btn btn-sm btn-success ml-auto" :disabled="processing === true" v-on:click="search()">
                Suche
              </Button>
            </div>
          </div>
        </div>
        <div class="col border-left" v-if="results != null && !processing">
          <div>
            <div class="font-weight-bold p-0">Suchergebnis</div>
            <small class="text-muted">Bitte einen Autoren aus der Liste auswählen oder händisch Eingeben.</small>
          </div>
          <Button class="btn btn-sm btn-primary mt-1" v-on:click="manually()">Händisch eingeben</Button>
          <div class="list-group mt-3 overflow-auto">
            <button type="button" class="list-group-item list-group-item-action" v-for="result in results"
                    v-bind:key="result.id" v-on:click="selectNewAuthor(result)">
              <div>
                <span v-if="result.lastname">{{ result.lastname }},&nbsp;</span>
                <span v-if="result.firstname">{{ result.firstname }}</span>
              </div>
              <div class="smaller">
                <div v-if="result.institute && result.institute.trim().length > 1">Institut: {{
                    result.institute
                  }}
                </div>
                <div v-if="result.department && result.department.trim().length > 1">
                  Abteilung: {{ result.department }}
                </div>
                <div v-if="result.city">Stadt: {{ result.city }}</div>
              </div>
            </button>
          </div>
        </div>
        <div class="col border-left" v-else-if="processing === true">
          <loader></loader>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Abbruch</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'submitter' && processing === true">
      <loader></loader>
    </div>
    <div v-else-if="importAuthor">
      <AuthorForm @authorCreated="authorCreated"></AuthorForm>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Abbruch</button>
          <Button class="btn btn-sm btn-primary ml-3" v-on:click="manually()">Händisch eingeben</Button>
        </div>
      </div>
    </div>
    <div v-else-if="importInstitute">
      <Instituteform @instituteCreated="instituteCreated"></Instituteform>
    </div>
  </div>
</template>

<script>
import entitegenerator from "entite-generator";
import {mapActions, mapGetters, mapState, mapMutations} from "vuex";
import AuthorForm from "../author/AuthorForm";
import Instituteform from "../author/InstituteForm";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Instituteform,
    AuthorForm,
    entitegenerator,
    Treeselect
  },
  name: "AuthorSearch",
  data() {
    return {
      importMode: 'search', //null, search, submitter
      searchfields: {},
      results: null,
      error: null,
      selected: null,
      importAuthor: false,
      importInstitute: false,
      processing: false,
      localmember: null
    };
  },
  computed: {
    ...mapState(["mode", "user"]),
    ...mapState('dgumember', ["selectedAuthor", "selectedInstitute", "membernumber", "validmember"])
  },
  mounted() {
    //@TODO: ÄNNDERN VOR COMMIT
    this.importMode = null;
  },
  methods: {
    ...mapActions('dgumember', ['GET_AUTHORS', 'GET_AUTHOR', 'VALID_MEMBER']),
    ...mapMutations('dgumember', ['SET_SELECTEDAUTHOR', 'SET_SELECTEDINSTITUTE']),
    ...mapMutations('dgumember', ['SET_VALID_MEMBER', 'SET_MEMBER_NUMBER']),
    async checkMember() {
      this.SET_VALID_MEMBER({'validMember': null});
      await this.VALID_MEMBER(this.localmember).then((result) => {
        this.SET_VALID_MEMBER({'validMember': true});
        this.SET_MEMBER_NUMBER({'membernumber': this.localmember})
        this.importMode = 'search';
      }).catch((error) => {
        this.localmember = null;
        this.SET_VALID_MEMBER({'validMember': false});
      });
    },
    async search() {
      this.error = null;
      if (this.processing === true) {
        return;
      }
      if (!this.searchfields.firstname && !this.searchfields.lastname && !this.searchfields.city) {
        this.error = 'Bitte einen Suchbegriff eingeben!';
        return;
      }
      this.processing = true;
      this.results = null;
      await this.GET_AUTHORS(this.searchfields).then((result) => {
        this.results = result.data;
      }).catch((error) => {
      });
      this.processing = false;
    },
    selectNewAuthor(data) {
      this.$set(this.mode, 'import', true);
      let mappedAuthor = {
        'external_id': data.id,
        'firstname': data.firstname.trim(),
        'lastname': data.lastname.trim(),
        'additional_content__dgu_mitglied': 'Ja',
        'additional_content__dgu_mitgliedsnummer': data.id,
        'additional_content__data_import': true,
        'additional_content__data_edited': false,
      };
      if (data.mail) {
        mappedAuthor.email = data.mail.trim();
      }
      if (data.mail_alternative) {
        mappedAuthor.email_alternative = data.mail_alternative.trim();
      }
      if (data.phone) {
        mappedAuthor.phone = data.phone.trim();
      }
      if (data.mobile) {
        mappedAuthor.cellphone = data.mobile.trim();
      }
      if (data.foa) {
        switch (data.foa) {
          case 'Herr':
            mappedAuthor.salutation_id = 1;
            break;
          case 'Frau':
            mappedAuthor.salutation_id = 2;
            break;
        }
      }
      if (data.titel) {
        mappedAuthor.title = data.titel.trim();
      }
      this.SET_SELECTEDAUTHOR({'selectedAuthor': mappedAuthor});
      this.selectNewInsitute(data);
      this.selected = data;
      this.importAuthor = true;
      this.importInstitute = false;
    },
    selectNewInsitute(data) {
      this.$set(this.mode, 'import', true);
      let mappedInstitute = {};
      mappedInstitute.additional_content__data_import = true;
      mappedInstitute.additional_content__data_edited = false;
      if (data.institute) {
        mappedInstitute.name = data.institute.trim();
      }
      if (data.department) {
        mappedInstitute.department = data.department.trim();
      }
      if (data.street) {
        mappedInstitute.street = data.street.trim();
      }
      if (data.city) {
        mappedInstitute.city = data.city.trim();
      }
      if (data.zipcode) {
        mappedInstitute.zip_code = data.zipcode.trim();
      }
      if (data.country_code) {
        mappedInstitute.country_code = data.country_code.trim().toUpperCase();
      }
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': mappedInstitute});
    },
    authorCreated(author_id) {
      this.selectedInstitute.author_id = author_id;
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': this.selectedInstitute});
      this.$store.dispatch('GET_ONE_AUTHOR', author_id);
      this.importAuthor = false;
      this.importInstitute = true;
    },
    instituteCreated() {
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id)
      this.cancel();
    },
    cancel() {
      this.$set(this.mode, 'import', false);
      $('#authorImportModal').modal('hide');
    },
    manually() {
      this.cancel();
      this.$emit('enterManually');
    }
  }
}
</script>

<style scoped>

</style>
